import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

const { colors } = constants;
const neutral600 = colors.ui.neutral[600];

export const modalFooterCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: "unset",
  flexWrap: "wrap",
};

export const teacherActionsWrapperCss: CSSObject = {
  display: "flex",
  gap: "16px",
  alignItems: "center",
  flexWrap: "wrap",
};

export const warningTextCss: CSSObject = {
  color: neutral600,
  ...typographyStyles.fontSize.textS,
  lineHeight: typographyStyles.lineHeight.textSLineHeights,
};

export const endAlignedButtonCss: CSSObject = {
  marginLeft: "auto",
};

export const hideOnMobileCss: CSSObject = {
  [breakpoint.upTo("xs")]: {
    display: "none",
  },
};

export const hideOnTabletAndUpCss: CSSObject = {
  [breakpoint.downTo("xs")]: {
    display: "none",
  },
};
